import { type VoiceStoreState, useVoiceStore } from '../voicesStore';

export const getLatestPlayingVoice = (state?: VoiceStoreState): VoiceStoreState['lastPlayingVoice'] => {
  state ??= useVoiceStore.getState();
  return state.lastPlayingVoice;
};
